import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NotificationService extends BaseService {

  constructor(http: HttpClient) {
    super(http);
  }

  async getNotifications(qp){
    return this.get(`notification${qp}`)
  }

  async readNotification(notificationId){
    return this.patch(`notification/${notificationId}`,{})
  }

}
